import { COURSE_PAYWALL_CLICK } from 'constants/gtmEvent';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { sendGTMEvent } from 'reduxModules/googleTagManager/action';

export default function usePaywallModalControl(
  courseId,
  courseName,
  currentLesson,
) {
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();

  const openPaywallModal = useCallback(() => {
    dispatch(
      sendGTMEvent({
        eventName: COURSE_PAYWALL_CLICK,
        data: {
          courseId,
          courseName,
          lessonId: currentLesson.id,
          lessonName: currentLesson.title,
        },
      }),
    );

    setIsOpen(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courseId, courseName, currentLesson.id]);

  const closePaywallModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    openPaywallModal,
    closePaywallModal,
    isOpenPaywallModal: isOpen,
  };
}
